import loopback from './loopback'
import Utils from './../utils'

let CDRDataSource = {}

export const HANGUPCAUSES_MAPPER = {
  'UNALLOCATED_NUMBER': 'Número não encontrado',
  'NORMAL_CLEARING': 'Atendida',
  'USER_BUSY': 'Ocupado',
  'NO_USER_RESPONSE': 'Sem resposta',
  'NO_ANSWER': 'Não atende',
  'CALL_REJECTED': 'Ligação rejeitada',
  'NUMBER_CHANGED': 'Caixa postal',
  'EXCHANGE_ROUTING_ERROR': 'Erro no roteamento da ligação',
  'SUBSCRIBER_ABSENT': 'Número fora de área',
  'INVALID_NUMBER_FORMAT': 'Formato de número inválido',
  'FACILITY_REJECTED': 'Ligação rejeitada',
  'NORMAL_CIRCUIT_CONGESTION': 'Congestionamento na operadora',
  'OUTGOING_CALL_BARRED': 'Ligação barrada',
  'INCOMPATIBLE_DESTINATION': 'Destino incompatível',
  'RECOVERY_ON_TIMER_EXPIRE': 'Tempo expirado',
  'ORIGINATOR_CANCEL': 'Cancelamento da ligação',
  'NO_ROUTE_DESTINATION': 'Erro no roteamento da ligação',
  'INTERWORKING': 'Ligação encerrada',
  'NORMAL_UNSPECIFIED': 'Temporariamente indisponível'
}

CDRDataSource.dataFromAPI = []
CDRDataSource.dataFromCache = []
CDRDataSource.lastCountData = 0

CDRDataSource.initialize = (filters) => {
  return retrieveDataFromAPI(filters)
}

CDRDataSource.refreshDataFromAPI = (filters) => {
  return retrieveDataFromAPI(filters)
}

function getCdrsFromApi (filter, page = 1) {
  return loopback
    .get([
      '/calls',
      `?${filter}`,
      `&page=${page}`,
      '&filter[limit]=1000'
    ].join(''))
    .then(cdrs => {
      if (cdrs) {
        if (cdrs.data) {
          CDRDataSource.dataFromAPI = CDRDataSource.dataFromAPI.concat(Array.from(cdrs.data))
        }
        if (cdrs.meta) {
          if (cdrs.meta.currentPage && cdrs.meta.totalItemCount && cdrs.meta.currentPage === 1) {
            if (cdrs.meta.totalItemCount === CDRDataSource.lastCountData) {
              CDRDataSource.dataFromAPI = [...CDRDataSource.dataFromCache]
              return Promise.resolve()
            }
            CDRDataSource.lastCountData = cdrs.meta.totalItemCount
          }
          if (cdrs.meta.nextPage) return getCdrsFromApi(filter, cdrs.meta.nextPage)
        }
      }
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

/**
 * Fetch entries from API.
 * @param {object} filters startedAt - start date to search, endedAt - end date to search
 * @returns
 */
function retrieveDataFromAPI (filters) {
  return new Promise((resolve, reject) => {
    CDRDataSource.dataFromCache = [...CDRDataSource.dataFromAPI]
    CDRDataSource.dataFromAPI = []
    let filter = ''
    if (filters.startedAt) { filter += `filter[where][and][0][started_at][gt]=${new Date(filters.startedAt).toISOString()}&` }
    if (filters.endedAt) { filter += `filter[where][and][1][ended_at][lt]=${new Date(filters.endedAt).toISOString()}&` }
    if (filters.callType) { filter += `filter[where][and][2][call_type]=${filters.callType}&` }
    filter += 'filter[order]=started_at asc'
    return getCdrsFromApi(filter).then(_ => {
      CDRDataSource.filters = filters
      return resolve()
    }).catch((err) => {
      return reject(err)
    })
  })
}

CDRDataSource.callStatistics = () => {
  return new Promise((resolve, reject) => {
    try {
      let calls = {}
      let answers = {}
      let durations = {}
      let callsZero = {}
      const type = ['today', 'yesterday'].includes(CDRDataSource.filters.name) ? 'hour' : 'date'
      if (CDRDataSource.dataFromAPI && CDRDataSource.dataFromAPI.length > 0) {
        calls = Utils.arrayReducer(CDRDataSource.dataFromAPI, 'count', 'id', {
          field: 'started_at',
          type: type
        })
        answers = Utils.arrayReducer(CDRDataSource.dataFromAPI, 'count', 'id', {
          field: 'started_at',
          type: type
        }, [
          {
            field: 'hangup_cause',
            type: 'include',
            value: 'NORMAL_CLEARING'
          },
          {
            field: 'duration',
            type: 'greaterThan',
            value: 1
          }
        ])
        durations = Utils.arrayReducer(CDRDataSource.dataFromAPI, 'sum', 'duration', {
          field: 'started_at',
          type: type
        }, [
          {
            field: 'hangup_cause',
            type: 'include',
            value: 'NORMAL_CLEARING'
          },
          {
            field: 'duration',
            type: 'greaterThan',
            value: 3
          }
        ])
      }
      if (type === 'hour') {
        for (let currentHour = 0; currentHour <= 23; currentHour++) {
          callsZero[currentHour] = 0
        }
      } else {
        for (
          let currentDay = new Date(CDRDataSource.filters.startedAt);
          currentDay <= new Date(CDRDataSource.filters.endedAt);
          currentDay.setDate(currentDay.getDate() + 1)
        ) {
          callsZero[currentDay.toISOString().split('T')[0]] = 0
        }
      }
      const objs = Utils.mergeObjects({ callsZero, calls, answers, durations }, 0, (type === 'hour'))
      return resolve({
        labels: Object.keys(objs.calls),
        calls: objs.calls,
        answers: objs.answers,
        durations: objs.durations
      })
    } catch (err) {
      return reject(err)
    }
  })
}

CDRDataSource.hangupcauseStatistics = () => {
  return new Promise((resolve, reject) => {
    try {
      if (CDRDataSource.dataFromAPI && CDRDataSource.dataFromAPI.length > 0) {
        let hangups = Utils.arrayReducer(CDRDataSource.dataFromAPI, 'count', 'id', {
          field: 'hangup_cause',
          type: 'string'
        })
        hangups = Utils.sortObjectValues(hangups, true, true)
        const labelsTranslated = Object.keys(hangups).map(hangupCause => {
          return HANGUPCAUSES_MAPPER[hangupCause] || hangupCause
        })
        return resolve({ labels: labelsTranslated, hangups })
      } else {
        return resolve({ labels: [], hangups: {} })
      }
    } catch (err) {
      return reject(err)
    }
  })
}

CDRDataSource.extensionStatistics = () => {
  return new Promise((resolve, reject) => {
    try {
      let calls = {}
      let extenUniq = {}
      let callsZero = {}
      const type = ['today', 'yesterday'].includes(CDRDataSource.filters.name) ? 'hour' : 'date'
      if (CDRDataSource.dataFromAPI && CDRDataSource.dataFromAPI.length > 0) {
        extenUniq = Utils.sortObjectValues(CDRDataSource.dataFromAPI.reduce((newObj, obj) => {
          let name = obj.first_name
          if (obj.last_name) {
            name += !name ? '' : ' '
            name += obj.last_name
          }
          Object.assign(newObj, { [name]: obj.from })
          return newObj
        }, {}))
        for (let extension in extenUniq) {
          let extensionCalls = Utils.arrayReducer(CDRDataSource.dataFromAPI, 'count', 'id', {
            field: 'started_at',
            type: type
          }, {
            field: 'from',
            type: 'include',
            value: extenUniq[extension]
          })
          calls[`${extension} (${extenUniq[extension]})`] = extensionCalls
        }
      }
      if (type === 'hour') {
        for (let currentHour = 0; currentHour <= 23; currentHour++) {
          callsZero[currentHour] = 0
        }
      } else {
        for (
          let currentDay = new Date(CDRDataSource.filters.startedAt);
          currentDay <= new Date(CDRDataSource.filters.endedAt);
          currentDay.setDate(currentDay.getDate() + 1)
        ) {
          callsZero[currentDay.toISOString().split('T')[0]] = 0
        }
      }
      const callsMerged = Object.keys(calls).reduce((obj, index) => {
        obj[index] = Utils.mergeObjects({ callsZero, calls: calls[index] }, 0, (type === 'hour')).calls
        return obj
      }, {})
      let labels = Object.keys(callsZero)
      return resolve({ labels, extensions: extenUniq, calls: callsMerged })
    } catch (err) {
      return reject(err)
    }
  })
}

export default CDRDataSource



// WEBPACK FOOTER //
// ./src/services/cdr-data-source.js